import { LOCATION_SEARCH, type LocationSearchInputProps } from '../constants/location'
import { useLocationAutocomplete } from '../hooks/useLocationAutocomplete'
import '../styles/location-search.scss'

export function LocationSearchInput({
  enabled = true,
  disabled = false,
  onSelect,
}: LocationSearchInputProps) {
  const {
    inputId,
    listId,
    query,
    setQuery,
    suggestions,
    open,
    setOpen,
    loading,
    error,
    selectSuggestion,
  } = useLocationAutocomplete({
    enabled: enabled && !disabled,
    onSelect,
  })

  return (
    <div className="location-search">
      <label className="form-field form-field--wide" htmlFor={inputId}>
        <span className="form-field__label">{LOCATION_SEARCH.label}</span>
        <input
          id={inputId}
          type="text"
          className="location-search__input"
          role="combobox"
          aria-expanded={open}
          aria-controls={listId}
          aria-autocomplete="list"
          placeholder={LOCATION_SEARCH.placeholder}
          value={query}
          disabled={disabled}
          autoComplete="off"
          onChange={(event) => {
            setQuery(event.target.value)
            setOpen(true)
          }}
          onFocus={() => {
            if (suggestions.length > 0) setOpen(true)
          }}
          onBlur={() => {
            window.setTimeout(() => setOpen(false), 150)
          }}
        />
      </label>

      {open && suggestions.length > 0 ? (
        <ul id={listId} className="location-search__list" role="listbox">
          {suggestions.map((suggestion) => (
            <li
              key={`${suggestion.lat}:${suggestion.lng}:${suggestion.label}`}
              role="option"
            >
              <button
                type="button"
                className="location-search__option"
                onMouseDown={(event) => event.preventDefault()}
                onClick={() => selectSuggestion(suggestion)}
              >
                <strong>{suggestion.label}</strong>
                {suggestion.city && suggestion.city !== suggestion.label ? (
                  <span>{suggestion.city}</span>
                ) : null}
              </button>
            </li>
          ))}
        </ul>
      ) : null}

      {loading ? (
        <p className="location-search__hint">{LOCATION_SEARCH.searching}</p>
      ) : error ? (
        <p className="location-search__hint location-search__hint--error">{error}</p>
      ) : (
        <p className="location-search__hint">{LOCATION_SEARCH.hint}</p>
      )}
    </div>
  )
}
